import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation PauseCOCampaign($id: ID!) {
    pauseContinuousOptimizationCampaign(id: $id) {
      id
      status
    }
  }
`;

export function pauseCOCampaign(id) {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
}
